function Row(currency, advanced_bonus, beginner_bonus) {
    return (
        <div className="row"></div>
    )
}
export default Row;
